module.exports = __webpack_public_path__ + "static/media/annaberg-back.64cc14b4.png";